<app-login-layout header="Please confirm your information">
  <form [formGroup]="form()" (ngSubmit)="onSubmit()">
    <formly-form [form]="form()" [fields]="formFields()" [model]="user()"></formly-form>
    <button type="submit" [disabled]="isSending() || !form().valid" data-cy="loginBtn" class="btn btn-primary">
      {{ isSending() ? 'Signing in...' : 'Sign in' }}
    </button>
  </form>
</app-login-layout>
